import React, { PropsWithChildren } from 'react'
import { StyleProp, Text, TextStyle, TouchableOpacity, ViewStyle } from 'react-native'
import { buttonStyle } from '../../theme/buttons'
import { CloseIcon } from '../Svg'
import { disabledGray, toqueColor } from '../../theme/colors'

interface Props extends PropsWithChildren {
  label?: string
  onPress: () => void
  customStyle?: StyleProp<ViewStyle>
  labelStyle?: StyleProp<TextStyle>
  disabled?: boolean
  closeIcon?: boolean
  variant?: 'orange' | 'white'
}

export const Button = ({
  label,
  onPress,
  customStyle,
  disabled,
  labelStyle,
  closeIcon,
  children,
  variant,
}: Props) => {
  return (
    <TouchableOpacity
      style={[
        buttonStyle.basic,
        variant === 'white' && buttonStyle.whiteBg,
        closeIcon && { flexDirection: 'row', justifyContent: 'space-around' },
        customStyle,
        disabled && { backgroundColor: disabledGray },
      ]}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={disabled}
    >
      {label && (
        <Text style={[buttonStyle.text, variant === 'white' && { color: toqueColor }, labelStyle]}>
          {label}
        </Text>
      )}
      {closeIcon && <CloseIcon width={21} height={20} />}
      {children}
    </TouchableOpacity>
  )
}
